<template>
  <div>
    <div class="row-title-card">
      <div class="card-img-left">
        <!-- 头像 -->
        <avatar
          :avatarUrl="avatarUrl"
          :size="avatarSize"
        ></avatar>
      </div>
      <div class="card-content-right">
        <div class="content-top">
          <!-- 名称 -->
          <div
            class="content-text"
            :style="{fontSize:contentFont+'px'}"
          >
            <slot name="name"></slot>

            <!-- icon -->
            <div
              class="icon-social"
              v-if="iconStyle"
            >
              <el-tooltip 
                trigger="hover"
                v-if="iconStyle.isShowPop"
                placement="bottom-start"
                content="帖子列表仅显示通过全球赢系统发布的帖子文章，如要查看全部，请在社媒主页的信息流中进行浏览"
              >
                <ig-icon
                  :name="iconStyle.name"
                  :style="{color:iconStyle.color}"
                ></ig-icon>
              </el-tooltip >
              <ig-icon
                slot="reference"
                v-else
                :name="iconStyle.name"
                :style="{color:iconStyle.color}"
              ></ig-icon>
            </div>
          </div>
        </div>

        <!-- 日期 -->
        <div
          class="content-date"
          v-if="dateTime"
        >
          <span>{{dateTime}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import avatar from "@/components/avatar";
export default {
  name: "rowTitleCard",
  props: {
    avatarUrl: String,
    avatarSize: [Number, String],
    iconStyle: Object,
    dateTime: String,
    contentFont: {
      type: [Number, String],
      default: 22
    }
  },
  components: {
    avatar
  }
};
</script>
<style lang="scss" scoped>
@import "@/client/styles/variables.scss";
@import "@/client/styles/mixin.scss";
@mixin text_ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.row-title-card {
  width: 100%;
  height: 100%;

  .card-img-left {
    float: left;
    margin-right: 22px;
  }
  .card-content-right {
    position: relative;
    .content-top {
      align-items: center;
      .content-text {
        @include text_ellipsis;
        font-weight: 500;
        color: $fontColor;
        * {
          @include text_ellipsis;
          display: inline-block;
          cursor: pointer;
        }
      }
    }
    .icon-social {
      margin-left: 16px;
      display: inline-block;
      position: absolute;
      top: 5px;
      i {
        font-size: 22px;
      }
    }
    .content-date {
      span {
        font-size: $fontSize_12;
        font-weight: 400;
        color: $fontColor;
        opacity: 0.66;
      }
    }
  }
}
</style>
